module.exports = __webpack_public_path__ + "img/06.beb2c21a.webp";